import { NavItem, CONTACT_SUPPORT_ITEM } from './navConfig';

// Primary client rail items. Paths match existing hash routes in app.js pages[].
// `account` keeps id 'account' (not 'companies') so unread-count plumbing keyed
// by id stays uniform with the staff rail; only the label differs.
export const CLIENT_NAV_ITEMS: NavItem[] = [
  { id: 'account', icon: 'building-2', label: 'Companies', path: '/' },
  {
    id: 'tasks',
    icon: 'square-check-big',
    label: 'My Tasks',
    path: '/my-tasks',
  },
  {
    id: 'messages',
    icon: 'message-square',
    label: 'Messages',
    path: '/my-conversations',
  },
  {
    id: 'notifications',
    icon: 'bell',
    label: 'Notifs',
    path: '/notifications',
  },
];

// Client "More" menu. Settings (/settings) is intentionally excluded: app.js gates
// it to userRole < 3, so an external user would land on notAvailable.
export const CLIENT_MORE_ITEMS: NavItem[] = [
  {
    id: 'legal',
    icon: 'scale',
    label: 'Legal Information Center',
    path: '/legal-information-center',
  },
  CONTACT_SUPPORT_ITEM,
];

// Mobile bottom bar: the four primary tabs + a synthetic "More" trigger (empty path).
export const CLIENT_MOBILE_TABS: NavItem[] = [
  ...CLIENT_NAV_ITEMS,
  { id: 'more', icon: 'ellipsis', label: 'More', path: '' },
];

/**
 * Maps a route pathname to the id of the matching client nav entry, or null when
 * no client entry owns it. Matches on the first path segment so detail routes
 * (e.g. /my-tasks/123) still resolve to their tab.
 */
export const clientPathnameToTabId = (pathname: string): string | null => {
  if (!pathname || pathname === '/') return 'account';
  const seg = `/${pathname.split('/')[1]}`;
  const match = [...CLIENT_NAV_ITEMS, ...CLIENT_MORE_ITEMS].find(
    (i) => i.path === seg
  );
  return match ? match.id : null;
};
